import { render } from "./account-remove.vue?vue&type=template&id=0de5c24c"
import script from "./account-remove.vue?vue&type=script&lang=js"
export * from "./account-remove.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__